import { render, staticRenderFns } from "./sectionItem.vue?vue&type=template&id=2f78ecba&scoped=true"
import script from "./sectionItem.vue?vue&type=script&lang=ts"
export * from "./sectionItem.vue?vue&type=script&lang=ts"
import style0 from "./sectionItem.vue?vue&type=style&index=0&id=2f78ecba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f78ecba",
  null
  
)

export default component.exports